/**
 *
 */
export type StepAction =
  | { type: 'COUNTRY_CITY'; payload: 'CLUB_BAR' }
  | { type: 'CLUB_BAR'; payload: 'LIST' | 'COUNTRY_CITY' }
  | { type: 'LIST'; payload: 'MAP' | 'CLUB_BAR' }
  | { type: 'MAP'; payload: 'MEET' | 'LIST' }
  | { type: 'MEET'; payload: 'CHAT' | 'MAP' }
  | { type: 'CHAT'; payload: 'MEET' };

export type StepState = {
  index: number;
  current: 'COUNTRY_CITY' | 'CLUB_BAR' | 'LIST' | 'MAP' | 'MEET' | 'CHAT';
};

export const initialStepState = (login: boolean): StepState => {
  return {
    index: login ? 1 : 3,
    current: login ? 'COUNTRY_CITY' : 'LIST',
  };
};

export const stepReducer = (state: StepState, action: StepAction) => {
  const steps = ['COUNTRY_CITY', 'CLUB_BAR', 'LIST', 'MAP', 'MEET', 'CHAT'];

  switch (action.type) {
    case 'COUNTRY_CITY':
    case 'CLUB_BAR':
    case 'LIST':
    case 'MAP':
    case 'MEET':
    case 'CHAT':
      return {
        ...state,
        current: action.payload,
        index: steps.indexOf(action.payload) + 1,
      };
  }
};

/**
 * Form
 */
export type FormAction =
  | { type: 'RESET' }
  | { type: 'COUNTRY'; payload: { id: string; label: string; key: string } }
  | { type: 'CITY'; payload: string }
  | { type: 'CLUB'; payload: string }
  | { type: 'BAR'; payload: string };

export type FormState = {
  country: { id: string; label: string; key: string };
  city: string;
  club: string;
  bar: string;
};

export const formInitialState: FormState = {
  country: { id: 'de', label: 'Deutschland', key: 'Germany' },
  city: '',
  club: '',
  bar: '',
};

export const formReducer = (state: FormState, action: FormAction) => {
  switch (action.type) {
    case 'RESET':
      return formInitialState;
    case 'COUNTRY':
      return { ...state, country: action.payload };
    case 'CITY':
      return {
        ...state,
        city: action.payload,
      };
    case 'CLUB':
      return {
        ...state,
        club: action.payload,
      };
    case 'BAR':
      return {
        ...state,
        bar: action.payload,
      };
  }
};
